import { Suspense, useState } from "react";
import { useRecoilValue } from "recoil";
import { useParams } from "react-router-dom"
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import VisualizeForm from "./visualize-form";
import VisualizeResults, { LoadingAlert } from "./visualize-results";
import ErrorBoundary from "../common/error-boundary";
import { formState } from "./visualize.state";
import { SidebarContainer, SidebarPanel, MainPanel } from "../common/sidebar-container";

export default function Analysis() {
  const form = useRecoilValue(formState);
  const { id } = useParams();
  const [_openSidebar, _setOpenSidebar] = useState(id ? false : true);
  return (
    <Container className="py-3">
      <Row>
        <SidebarContainer collapsed={!_openSidebar} onCollapsed={() => _setOpenSidebar(!_openSidebar)}>
          <SidebarPanel>
            <Col>
              <div className="shadow p-3 rounded" style={{ minHeight: "400px" }}>
                <ErrorBoundary
                  fallback={
                    <strong>An internal error occured when loading form parameters. If this issue persists, please contact the site administrator.</strong>
                  }
                >
                  <Suspense fallback={<strong>Loading</strong>}>
                    <VisualizeForm onSubmit={ev => _setOpenSidebar(false)} />
                  </Suspense>
                </ErrorBoundary>
              </div>
            </Col>
          </SidebarPanel>
          <MainPanel>
            <Col>
              <div className="shadow p-2 rounded" style={{ minHeight: "400px" }}>
                <ErrorBoundary
                  fallback={<strong>An internal error occured when loading results. If this issue persists, please contact the site administrator.</strong>}
                >
                  <Suspense fallback={id && <LoadingAlert params={form} />}>
                    <VisualizeResults  />
                  </Suspense>
                </ErrorBoundary>
              </div>
            </Col>
          </MainPanel>
        </SidebarContainer>
      </Row>
    </Container>
  );
}
